export { default as HeadingTwo } from './HeadingTwo';
export { default as HeadingThree } from './HeadingThree';
export { default as HeadingFour } from './HeadingFour';
export { default as HeadingFive } from './HeadingFive';
